export default __webpack_public_path__ + "static/media/desktop_86.62090e6d.jpg";